import { requestJson } from '../../module-system/api.js';

export const refreshVerification = (token, id) => requestJson(`/modules/didit/verifications/${encodeURIComponent(id)}/refresh`, { token, method: 'POST' });
